import { Root } from 'react-dom/client';
import './polyfills';
import { EventManager } from './services/event-manager';
import { setLowerCaseFirstLetter } from 'helpers/configuration-helpers';
import { ThemeEnum } from 'types/market-types';

const selectorName = 'insurance-calculators-container';

export let appRoot: Root | null = null;

export const setAppRoot = (root: Root | null): void => {
  appRoot = root;
};
class AppRender extends HTMLElement {
  eventManager = new EventManager();

  destroyCalculator(): void {
    this.eventManager.destroyCalculator();
    appRoot?.unmount();
    appRoot = null;
  }

  // Called everytime custom element is addded to the DOM
  connectedCallback(): void {
    const attributeIsInit = this.getAttribute('initContainer') || 'false';
    this.eventManager.setIsInit(JSON.parse(attributeIsInit) || false);
    if (this.eventManager.getIsInit()) {
      this.render();
    }
  }

  disconnectedCallback(): void {
    this.destroyCalculator();
  }

  render(): void {
    const appSelector = this.getAttribute('target') || `#${this.getAttribute('id')}` || `#${selectorName}`;
    const attributeInBody = this.getAttribute('location') || '';
    const inBody = attributeInBody === 'body';
    const attributeConfiguration = this.getAttribute('configuration') || '';
    const attributeConfigurationObject = JSON.parse(attributeConfiguration);
    const configuration: TimApp.MarketConfiguration | null = setLowerCaseFirstLetter(attributeConfigurationObject);
    this.eventManager.appSelector = appSelector;
    this.eventManager.appSelector$ = this;
    this.eventManager.configuration = configuration;
    configuration.elementType = configuration.elementType || 'newCarsSimulator';
    const speedboat = configuration?.parameters?.Origin === ThemeEnum.speedboat ? ThemeEnum.speedboat : null;
    this.eventManager.inBody = inBody;
    const theme =
      configuration.elementType === 'newCarsSimulator'
        ? speedboat || (this.getAttribute('theme') as ThemeEnum) || ThemeEnum.default
        : ThemeEnum.default;
    this.eventManager.theme = theme;
    if (configuration) {
      configuration.inBody = inBody;
    }
    this.eventManager.init();
  }

  componentWillUnmount(): void {
    this.destroyCalculator();
  }

  // Called whenever any observed attribute get updated, added, removed, replaced
  attributeChangedCallback(
    attrName = '', // eslint-disable-line @typescript-eslint/default-param-last
    oldVal: string | boolean,
    newVal: string | boolean
  ): void {
    if (newVal === 'true' || newVal === true) {
      this.render();
    }
  }

  // Specifies the list of attribute names to be observed
  static get observedAttributes(): object {
    return ['initcontainer'];
  }
}

if (!customElements.get(selectorName)) {
  customElements.define(selectorName, AppRender);
}
